import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { HomeHero } from "@/pages/home/HomeHero";
import { FingerSection, PromoCards, DeviceSection, FeaturesSection, StatementBand, CarouselBand } from "@/pages/home/HomeSections";

export default function Home() {
  const { content: c } = useSite();
  useSeo("home");
  return (
    <div data-testid="home-page">
      <HomeHero h={c.hero} />
      <FingerSection s={c.finger} />
      <PromoCards c={c.cards} />
      <DeviceSection s={c.device} />
      <FeaturesSection f={c.features} />
      <StatementBand s={c.statement} />
      <CarouselBand title={c.members.title} images={c.members.images} id="members" className="bg-[#EFEFEF] w-full" />
      <div className="max-w-[1400px] mx-auto">
        <CarouselBand title={c.editions.title} images={c.editions.images} id="editions" className="bg-ivory" />
      </div>
    </div>
  );
}
